module.exports = {
  path: 'faq',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Faq'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/more/routes/faq/index.js